import { render, staticRenderFns } from "./OvertimeRequestApproved.vue?vue&type=template&id=ae0d2dac"
import script from "./OvertimeRequestApproved.vue?vue&type=script&lang=js"
export * from "./OvertimeRequestApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports